import { createSlice } from "@reduxjs/toolkit";
import { fetchrecordLevelInstock, fetchReorderLevelDetail } from "./thunk";

interface DistrictState {
  recordLevelInStockList: any[];
  currentReorderLevel: any | null; // Added state for detail view
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: DistrictState = {
  recordLevelInStockList: [],
  currentReorderLevel: null,
  rowCount: 0,
  loading: false,
  error: null,
};

const inventoryRecordLevelinStockSlice = createSlice({
  name: "recordLevelIteamWiseReducer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchrecordLevelInstock.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchrecordLevelInstock.fulfilled, (state, action) => {
        state.loading = false;
        state.recordLevelInStockList = action.payload.data;
        state.rowCount = action.payload.rowCount;
        console.log("action.payload", action.payload);
      })
      .addCase(fetchrecordLevelInstock.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch fetchrecordLevelInstock";
      })
      // Handle fetchReorderLevelDetail
      .addCase(fetchReorderLevelDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.currentReorderLevel = null;
      })
      .addCase(fetchReorderLevelDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.currentReorderLevel = action.payload;
      })
      .addCase(fetchReorderLevelDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch Reorder Level details";
      });
  },
});

export default inventoryRecordLevelinStockSlice.reducer;
